import React from "react";
import MainLayout from "../../../hoc/main";
import {FormContainer, Grid, Input} from "../../../components";
import {connect} from "react-redux";
import {addIntentData} from "../../../redux/modules/Intent/action";
import {Button} from "../../../components/Button";
import {Redirect} from "react-router-dom";

class IntentAdd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            displayName: "",
        };
    }

    onChangeValue = (e) => {
        const {value, name} = e.target;

        this.setState({
            [name]: value,
        });
    };

    onChangeCheckBox = (e) => {
        const {checked, name} = e.target;
        this.setState({
            [name]: checked,
        });
    };

    finishForm(e) {
        e.preventDefault();
        this.props.addIntentData(this.state);
    }

    render() {
        if (this.props.intent?.success) return <Redirect to="/intent"/>;
        return (
            <div className="p-6 mt-20 xl:mt-0 ">
                <Grid>
                    <FormContainer className={`pt-0`}>
                        <Input
                            name={"displayName"}
                            label={"Intent name"}
                            value={this.state.displayName}
                            placeholder={"Lorem"}
                            className={"w-full md:w-1/2 xl:w-1/3"}
                            onChange={this.onChangeValue}
                        />
                        <hr className={`my-5`}/>
                        <Button
                            className={`bg-green-200 text-green-700`}
                            onClick={this.finishForm.bind(this)}
                        >
                            Submit
                        </Button>
                    </FormContainer>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    intent: state.intent,
});

const mapDispatchToProps = {
    addIntentData,
};

export default MainLayout(
    connect(mapStateToProps, mapDispatchToProps)(IntentAdd)
);
